
import { Props_SnippetContentColumn } from './ContentColumn.props'
import { CompileMarkdown } from '../../../../Shared/AttraxTs/React/ReactSnippetMDCompiler'
import SnippetLink from '../Shared/Link/Link'
import SharedHeading from '../Shared/Heading/Heading'

const SnippetContentColumn = (props: Props_SnippetContentColumn) => {
    const { heading, content, repeatable_entry } = props
        const headingLevel = heading.level?.value as 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6' || 'h2';

    return (
        <section className={`snippet-content-column`}>
            <div className={`snippet-content-column__container`}>
                <div className="snippet-content-column__container-content">
                    <SharedHeading
                        className="snippet-content-column__heading"
                        level={headingLevel}
                        alignment={typeof heading.alignment?.value === 'string' && ['start','center','end'].includes(heading.alignment.value) ? heading.alignment.value as any : undefined}
                        visibility={typeof heading.visibility?.value === 'boolean' ? heading.visibility.value : heading.visibility?.value === 'true'}
                    >
                        {heading.text?.value}
                    </SharedHeading>
                    { content.content?.value && typeof content.content.value === 'string' && (
                        <div className="snippet-content-column__content">
                            {CompileMarkdown(content.content.value)}
                        </div>
                    )}
                </div>
                <div className="snippet-content-column__container-entries">
                    { repeatable_entry.map((entry, index: number) => {
                            const classSnippetMode: string = typeof entry.mode?.value === 'string' ? `snippet-content-column__entry--mode-${entry.mode.value}` : ''

                        return (
                            <div key={index} className={`snippet-content-column__entry ${classSnippetMode}`}>
                                { entry.image?.value && typeof entry.image.value === 'string' && (
                                    <figure className="snippet-content-column__entry-image-container">
                                        <img
                                            className="snippet-content-column__entry-image"
                                            loading="lazy"
                                            height={entry.mode?.value === 'images' ? 300 : 120}
                                            width={entry.mode?.value === 'images' ? 425 : 120}
                                            src={entry.image.value}
                                        alt={typeof entry.alt?.value === 'string' ? entry.alt.value : ''}
                                    />
                                </figure>
                            )}
                            <div className="snippet-content-column__entry-content-container">
                                <SharedHeading
                                    className="snippet-content-column__entry-heading"
                                    level={typeof entry.level?.value === 'string' && ['h1','h2','h3','h4','h5','h6'].includes(entry.level.value) ? entry.level.value as any : 'h3'}
                                    alignment={typeof entry.alignment?.value === 'string' && ['start','center','end'].includes(entry.alignment.value) ? entry.alignment.value as any : undefined}
                                    visibility={typeof entry.visibility?.value === 'boolean' ? entry.visibility.value : entry.visibility?.value === 'true'}
                                >
                                    {entry.text?.value}
                                </SharedHeading>
                                { entry.content?.value && typeof entry.content.value === 'string' && <div className="snippet-content-column__entry-content">{ CompileMarkdown(entry.content.value) }</div> }
                                <SnippetLink
                                    linkStyles={typeof entry.linkStyle?.value === 'string' ? entry.linkStyle.value : undefined}
                                    className="snippet-content-column__entry-link"
                                    url={typeof entry.linkHref?.value === 'string' ? entry.linkHref.value : undefined}
                                    openInNewTab={typeof entry.linkTarget?.value === 'boolean' ? entry.linkTarget.value : entry.linkTarget?.value === 'true'}
                                >
                                    {typeof entry.linkText?.value === 'string' ? entry.linkText.value : ''}
                                </SnippetLink>
                            </div>
                        </div>
                    )
                    } )}
                </div>
            </div>
        </section>
    )
}

export default SnippetContentColumn